export const REFRESH_USER_COUNT = "REFRESH_USER_COUNT";

import { get, put, post, destroy, upload } from "utils/fetchRequest";

export const getConnectList = async (searchText) => {
  try {
    const result = await get(
      `connect${searchText ? `?search=${encodeURIComponent(searchText)}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getConnectContent = async (newsId) => {
  try {
    const result = await get(`connect/${newsId}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const createConnect = async (data) => {
  try {
    const result = await post("connect", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateConnect = async (id, data) => {
  try {
    const result = await put(`connect/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const deleteConnect = async (id) => {
  try {
    const result = await destroy(`connect/${id}`);

    return result;
  } catch (err) {
    return { error: err };
  }
};
